import { MutationTree } from 'vuex'
import { LangState } from './types'
import store from '..'
import config from 'config'
import router from '@/router'
import { isEmpty } from '@/helpers/utils'

export const mutations: MutationTree<LangState> = {
  async SET_LOCALE (state, payload: string) {
    state.locale = payload
    if (!isEmpty(state.translations)) {
      await store.dispatch('LANG/loadLangs', config.i18n.files)
      if (router.currentRoute.params.lang !== state.locale) {
        router.push(state.locale)
      }
    }
  },

  SET_TRANSLATION (state, payload) {
    state.translations = {
      ...state.translations,
      ...payload
    }
  }
}
